import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Typeruns } from '../../core/entities/typeruns.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TyperunsService {
    readonly BASE: any = PETICIONES.typeruns;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los typeruns
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un typeruns por su id
   */
  public findById(id: number): Observable<any> {
    let idtyperuns: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idtyperuns).pipe(delay(DELAY));
  }

   /**
   * @description
   * Guarda un typeruns en la base de datos
   */
  public postTyperun(typeruns: Typeruns): Observable<any> {
    const json = JSON.stringify(typeruns);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postTyperuns, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un typeruns en la base de datos
   */
  public deleteTyperun(typeruns: Typeruns): Observable<any> {
    let idtyperuns: string = (typeruns.id !== undefined && typeruns.id !== null ? typeruns.id + "" : "");
    return this.http.get(this.BASE.deleteTyperuns + "/" + idtyperuns).pipe(delay(DELAY));
  }

}